/** No account data travels in these events. Each listener rechecks its own actor. */
export const COMPANION_SHARED_PLANS_CHANGED = "peakwave-companion-shared-plans-changed";
